const $mm = {
    number_map: {
        '1': "၁",
        '2': "၂",
        '3': "၃",
        '4': "၄",
        '5': "၅",
        '6': "၆",
        '7': "၇",
        '8': "၈",
        '9': "၉",
        '0': "၀",
    },
    HEY: "ဟိုင်း",
    YOU_ARE_ON: "လက်ရှိအခြေအနေ",
    LEVEL: "အဆင့်",
    SPIN_NOW: "လှည့်ပါ",
    SPIN_NOW_2: "လှည့်\nပါ",
    QUESTIONS: "မေးခွန်းများ",
    MINUTES: "မိနစ်",
    PLAY_FREE: "အခမဲ့ကစားပါ",
    PLAY_USING: "ကစားပါ",
    USING_COINS: "ဒင်္ဂါးများ",
    LATEST_TOURNAMENTS: "နောက်ဆုံးပြိုင်ပွဲအသစ်များ ",
    DAILY_TOURNAMENTS: "နောက်ဆုံးပြိုင်ပွဲအသစ်များ ",
    MEGA_TOURNAMENTS: "ရင်ခုန်စိတ်လှုပ်ရှားဖွယ်ပြိုင်ပွဲများ",
    LATEST_CHALLENGE_ROOM: " နောက်ဆုံးစိန်ခေါ်မှုအသစ်များ",
    SEE_ALL: "အားလုံးကြည့်မည်",
    CATEGORIES: "လေ့ကျင့်ရန် ဥာဏ်စမ်းများ",
    TOP_TOPICS: "ထိပ်ဆုံးခေါင်းစဥ်များ",
    YOUR_INTEREST: "သင့်စိတ်ဝင်စားမှု ",
    YOU_HAVE_COMPLETED: " သင့်ရဲ့ဖြေဆိုမှု ပြီးပါပြီ",
    LEADERBOARD: "ဦးဆောင်သူစာရင်း",
    STORE: "စတိုး ",
    FRIENDS: "သူငယ်ချင်း ",
    REFER: " ညွှန်းဆိုသူ",
    DAILY: " နေ့စဥ်",
    WEEKLY: "အပတ်စဥ် ",
    MONTHLY: "လစဥ်",
    REQUEST: "တောင်းဆိုချက်",
    LANGUAGE: "တောင်းဆိုချက်",
    SENT_REQUEST: "ောင်းဆိုချက်ပေးပို့သည်",
    YOU_HAVE_NO_FRIENDS:
        "သင့်မှာ သူငယ်ချင်း မရှိသေးပါဘူး။"
    ,
    EMPTY_REQUEST: "တောင်းဆိုချက်မရှိသေးပါ ",
    YOU_CAN_ADD_FRIEND: " သူငယ်ချင်းအသစ်များကိုဖိတ်ခေါ်နိုင်ပါတယ်။",
    SEARCH_FRIEND: " သူငယ်ချင်းအသစ်များရှာဖွေပါ",
    TERMS_CONDITION: "စည်းကမ်းသတ်မှတ်ချက်များ",
    PRIVACY: "ကိုယ်ရေးအချက်အလက်မူဝါဒ",
    COINS: "ဒင်္ဂါးများ ",
    GEMS: "Gems",
    YOUR_BALANCE: "လက်ကျန်ငွေ",
    BUY_NOW: "ဝယ်မည်",
    BDT: "MMK",
    TOP_DEALS: "အတန်ဆုံး ကမ်းလှမ်းချက်များ",
    POPULAR_PRODUCTS: "လူကြိုက်များသော ဝန်ဆောင်မှုများ",
    RS: "RS",
    SEARCH_TOPICS: "ခေါင်းစဥ်ရှာမည်",
    PROFILE: "အကောင့်",
    NOTIFICATIONS: "အသိပေးချက်များ ",
    SETTINGS: "ဆက်တင်",
    CHALLENGES: " စိန်ခေါ်မှုများ",
    NO_HISTORY_AVAILABLE: "မှတ်တမ်းမရရှိနိုင်ပါ။",
    PURCHASE_HISTORY: "ဝယ်ယူမှုမှတ်တမ်း",
    INVITE_FRIENDS: " သူငယ်ချင်းဖိတ်ခေါ်ရန်",
    RATE_QUIZGIRI: "QuizGiri ကို အဆင့်သတ် မှတ်မယ်",
    CHALLENGE_WINNING_STATUS: " စိန်ခေါ်မှုတွင်အနိုင်ရခြင်းအခြေအနေ"
    ,
    WIN: "နိုင်သည်",
    DRAW: "သရေ ",
    LOSS: "ရှုံးသည်",
    BCS_TEST_RESULT: "BCS စာမေးပွဲရလဒ် ",
    TODAY: "ဒီနေ့",
    THIS_WEEK: "ဒီအပတ် ",
    THIS_MONTH: "ဒီလ",
    MODEL_TEST_PARTICIPATED: "အစမ်းဖြေဆိုမှုတွင် ပါဝင်ခဲ့သည်။ "
    ,
    QUESTION_ANSWERED: "အမေးအဖြေ ",
    MARK: "အမှတ်",
    CORRECT: " အမှန်",
    WRONG: "အမှား ",
    SKIPPED: " ကျော်မည်",
    CANCEL: " မဖျက်ပါ",

    EDIT_PROFILE: "ပရိုဖိုင်ပြင်မည် ",
    FULL_NAME: "အမည် ",
    MOBILE: " ဖုန်းနံပါတ်",
    EMAIL: "အီးမေးလ် ",
    SAVE: "သိမ်းမည်",
    WEEKLY_TASK: "Weekly Task",
    DAY: " နေ့",
    PLAY_NOW: "ကစားမည်",
    FREE_QUIZ_PLAY: "အခမဲ့ ပဟေဠိဖြေရန်",
    OUT_OF_COIN: "ဒင်္ဂါးကုန်နေပါသည်",
    STARTING_NOW: " စမည်",
    ALREADY_PLAYED: " ",
    RECENT_BEST: " ",
    REPORT: "ရီပို့ ",
    NEXT: "နောက်တခု ",
    USE_COIN: " ဒင်္ဂါးသုံးမည်",
    SEE_RESULT: " ရလဒ်ကြည့်ရန်",
    WATCH_VIDEO: "ভিডিও দেখুন",
    TI: " ",
    YOU_HAVE_GIVEN: "ပေးပြီးသားဖြစ်ပါတယ်။",
    CORRECT_ANS: "အဖြေမှန် ",
    TOTAL_QUESTION: "မေးခွန်းစုစုပေါင်း ",
    THANKS_FOR_PLAYING: " ပါဝင်ကစားတဲ့အတွက် ကျေးဇူးတင်ပါတယ်။",
    YOU_HAVE_COMPLETED_TODAYS_TASK: "ဒီနေ့အတွက် မေးခွန်းအားလုံးဖြေဆိုပြီးပါပြီ။ "
    ,
    DONE: "ပြီးပါပြီ",
    TIME: " အချိန်",
    PENALTY: " ဒဏ်ကြေး",
    WRONG_QUESTION: " မေးခွန်းမှား",
    WRONG_ANSWER: " အဖြေမှား",
    OTHERS: "အခြား ",
    SUBMIT: " ပေးပို့သည်",
    REPORTED: "အသိပေးမည်",
    SUBMITTED: "ပေးပို့ပြီးပါပြီ ",
    PLEASE_CONFIRM: " အတည်ပြုပေးပါ",
    FOLLOW: "စောင့်ကြည့်မည်",
    FAQ: "အမေးများသောမေးခွန်းမျာ",
    FOLLOWING: "အချက်အလက်ရယူနေသည် ",
    FOLLOWER: "ပါဝင်စောင့်ကြည်သူများ ",
    YOUR_LEVEL: "ရောက်ရှိနေသောအဆင့်",
    NEXT_LEVEL: "နောက်တစ်ဆင့်သို့",
    PLAY: "ကစားမည်",
    EXPLORE: "ဂိမ်းများရှာဖွေရန်",
    CHOOSE_BET_AMOUNT: "လောင်းကြေးပမာဏရွေးချယ်ရန်",
    TYPE_OF_CHALLENGE: " စိန်ခေါ်မှုအမျိုးအစားများ",
    SINGLE_TOPIC: "အကြောင်းအရာတစ်ခုချင်း",
    GLOBAL: "အကြောင်းအရာအားလုံး",
    SELECT_TOPIC_CATEGORY: "အကြောင်းအရာအမျိုးအစားရွေးချယ်ပါ"
    ,
    SELECT_TOPIC: "အကြောင်းအရာရွေးချယ်ပါ",
    SELECT_QUESTION_AMOUNT: "မေးခွန်းပမာဏရွေးချယ်ရန်",
    CONFIRM: "အတည်ပြုရန်",
    CHALLENGE_NOW: "ယခုပဲစိန်ခေါ်မှုစတင်လိုက်ပါ",
    RESULT: "ရလဒ်",
    HOME: "အိမ်",
    ACCEPTED: "လက်ခံသည်",
    ACCEPT: "လက်ခံသည်",
    REJECTED: "ပယ်ချသည်",
    REJECT: "ပယ်ချသည် ",
    CANCELLED: "ဖျက်မည်",
    PENDING: "ဆိုင်းငံ့သည်",
    NO_CHALLENGE: "စိန်ခေါ်မှုမလုပ်သေးပါ",
    CHALLENGE: "စိန်ခေါ်မှုစတင်မည်",
    COMPLETED: "ပြီးဆုံးပြီ",
    OPPONENT_PLAYED: "ယှဉ်ပြိုင်ကစားခဲ့သည်",
    OPPONENT_NOT_PLAYED: "ယှဉ်ပြိုင်မှုမစတင်သေးပါ",
    PLAYED: "ကစားပြီးပြီ",
    CONGRATULATION: "ဂုဏ်ယူပါတယ်",
    YOU_HAVE_SUCCESSFULLY_PURCHASED: "ဝယ်ယူမှုအောင်မြင်ပါသည်"
    ,
    NOW_YOU_CAN_PARTICIPATE_TOURNAMENT: "ယခုပြိုင်ပွဲတွင်ပါဝင်နိုင်ပါပြီ"
    ,
    GO_HOME: "မူလနေရာသို့ပြန်သွားမည်",
    YOU_WON: "သင်အနိုင်ရပါပြီ",
    YOU_CAN_SPIN_ONLY_ONCE:

        "တစ်နေ့လျင်တစ်ကြိမ်တည်းသာလှည့်နိုင်ပါသည်။ သို့သော် ကြော်ညာကြည့်ပြီးပါက ထပ်လှည့်ခွင့်ရရှိပါမည်",
    DAILY_SPIN: "နေ့စဉ်လှည့်ပါ",
    YOUR_NEXT_SPIN: "နောက်တစ်ကြိမ်လှည့်ခွင့် ရရှိနိုင်ပါမည်",
    SHARE: "မျှဝေမည်",
    NOTHING_FOUND: "မည်သည့်အရာမျှမတွေ့ရှိပါ",
    THIS_YEAR: "ယခုနှစ်",
    FILTER: "စီစစ်ရွေးချယ်မည်",
    SEARCH_WITH_NAME_OR_EMAIL: "အမည်(or) emailဖြင့်ရှာပါ",
    PEOPLE_FROM_CONTACT: "သင့်အဆက်အသွယ်ထဲမှမိတ်ဆွေများ"
    ,
    SELECT_FRIEND: "မိတ်ဆွေများထဲမှရွေးပါ",
    DAILY_UPDATE: "နေ့စဉ်အသစ်များ",
    NEW_TOPIC: "အကြောင်းအရာအသစ်",
    NEW_TOURNAMENT: "ပြိုင်ပွဲအသစ်",
    SOUND_EFFECT: "အသံအမျိုးမျိုး",
    MUSIC: "ဂီတ",
    LOGOUT: "ထွက်မည်",
    TOURNAMENT: "ပြိုင်ပွဲ",
    CHALLENGE_ROOM: "စိန်ခေါ်မှုကဏ္ဍ ",
    PARTICIPANTS_ARE_PLAYING: "ပြိုင်ပွဲဝင်များယှဉ်ပြိုင်နေသည်",
    TIME_UP: "အချိန့်ပြည့်ပြီ",
    SUBSCRIBE_NOW: "ယခုပါဝင်မည်"
    ,
    UNSUBSCRIBE_NOW: "ပယ်ဖျက်ရန်"
    ,
    YOU_CANT_PLAY_MORE: "ကစားခွင့်ကုန်ဆုံးပါပြီ"
    ,
    PARTICIPATE_IN_OTHER_TOURNAMENTS: "တခြားပြိုင်ပွဲများတွင် ပါဝင်မည်"
    ,
    FIFTY_FIFTY: "၅၀:၅၀",
    GET_ANSWER: "အဖြေကြည့်ရန်",
    BKASH: "bKash အကောင့်နှင့်တခြား",
    REMOVE_BKASH_ACCOUNT: "bKash အကောင့်ကိုဖယ်မည်",
    ADD_BKASH_ACCOUNT: "သင့် bKash အကောင့်နှင့်ချိတ်ဆက်ပါ",
    TOTAL_POINTS: "စုစုပေါင်းအမှတ်",
    HIGH_SCORE_IN_ANY_TOPIC: "အကြောင်းအရာအားလုံးတွင်အမှတ်အများဆုံး",

    TOURNAMENT_WIN: "ပြိုင်ပွဲတွင် အနိုင်ရရှိသည်",
    ADD_FRIEND: "မိတ်ဆွေဖွဲ့မည်",
    CANCEL_REQUEST: "တောင်းဆိုချက်ကိုပယ်ဖျက်မည်",
    ACCEPT_REQUEST: "တောင်းဆိုချက်ကိုလက်ခံသည်",
    REQUEST_SENT: " တောင်းဆိုချက်ပေးပို့သည်",
    UNAVAILABLE: "မရရှိနိုင်ပါ",
    REMATCH: "ထပ်မံကစားပါ",
    OKAY: "အဆင်ပြေသည်",
    USE_OF_COIN: "ဒင်္ဂါးများအသုံးပြုခြင်း",
    USE_OF_COIN_1:
        "1. သင့်မိတ်ဆွေကိုစိန်ခေါ်မှုပြုလုပ်မည်ဆိုပါက သင့်ထံတွင်အနည်းဆုံးလောင်းကြေး ‌ဒင်္ဂါးပမာဏရှိရန်လိုအပ်ပါသည်",
    USE_OF_COIN_2:

        "2. အထွေထွေပဟေဠိနှင့် စိန်ခေါ်မှု များမှ မေးခွန်းများကို ထပ်မံဖြေဆိုရန် သင့် ဒင်္ဂါးများကို အသုံးပြုနိုင်သည် "
    ,
    USE_OF_COIN_3:

        "3. ပြိုင်ပွဲကစားနေချိန်တွင် ဒင်္ဂါးများကို သုံးစွဲပြီး သင့်ကစားပွဲကိုဆက်ကစားနိုင်ပါသည် "
    ,


    USE_OF_GEM: "",
    USE_OF_GEM_1:
        "1. သင့်အနေဖြင့် ပြိုင်ပွဲကစားနေစဉ်အတွင်း Gem များကို သုံးစွဲခြင်းဖြင့် မေးခွန်းအဖြေမှန်ကို ရနိုင်ပါတယ်",

    SURE_TO_EXIT: "သင်ထွက်ဖို့သေချာပါသလား",
    SURE_TO_UNSUBSCRIBE: "ဝန်ဆောင်မှု ပယ်ဖျက်မှာ သေချာပါသလား။",


    YES: "ထွက်မယ်",

    NO: "မထွက်ပါ",
    YOU_HAVE_NOT_SUBMITTED_ANSWERS: "သင့်အဖြေတွေကို မပေးပို့ရသေးပါ",
    SURE_TO_QUIT: "သင်ထွက်ဖို့သေချာပါသလား",

    YOU_HAVE_NOT_COMPLETED_THE_GAME: "ဂိမ်းကို အဆုံးထိ မကစားရသေးပါ။",
    TRY_AGAIN: "နောက်တစ်ကြိမ်ကြိုးစားကြည့်ပါ",
    NEXT_TOPIC: "နောက်အကြောင်းအရာသို့",
    NOT_BAD: "မဆိုးပါဘူး",
    BETTER_LUCK_NEXT_TIME: "နောက်တစ်ကြိမ်ပိုကံကောင်းပါစေ",
    YOU_HAVE_PASSED:
        "သင် ဒီအဆင့်ကို အောင်မြင်သွားပါပြီ",

    YOU_HAVE_FAILED:
        "သင် ဒီအဆင့်ကို မအောင်မြင်ပါ",

    NO_IMPROVEMENT: "သင်မှာ တိုးတက်မှုမရှိသေးပါ",

    PLEASE_NOTE: "ကျေးဇူးပြုပြီးမှတ်သားထားပါ",

    TOTAL_CHANCE: "စုစုပေါင်းအခွင့်အရေးများ",

    CHANCE_PLAYED: "ကစားခွင့်များ",

    START: "စမယ်",
    START_TIME: "စတင်ချိန်",
    END_TIME: "ပြီးဆုံးချိန်",
    ENTER_PASSCODE: "လျှို့ဝှက်ကုဒ်ကို ထည့်ပါ။",

    VERIFY: "အတည်ပြုပါ",

    PAY_TO_PLAY: "ကစားရန် ငွေပေးချေပါ",

    WILL_PUBLISH_RESULT_SOON: "ရလဒ်ကို မကြာမီ ထုတ်ပြန်ပါမည်။",

    SORRY: "ဝမ်းနည်းပါတယ်။",
    SORRY_MSG: "ဝဝန်ဆောင်မှုရပ်ဆိုင်းခြင်း မအောင်မြင်ပါ။",
    SUCCESS: "အောင်မြင်ပါတယ်",
    SUCCESS_MSG: "ဝန်ဆောင်မှုရပ်ဆိုင်းပြီးပါပြီ။",
    FEATURE_AVAILABLE_IN_APP: "ဤအရာကို မရရှိနိုင်ပါ",

    DOWNLOAD_NOW: " ယခုဒေါင်းလုဒ်လုပ်ပါ",
    WHY_DOWNLOAD_APP:
        " ပိုမိုစိတ်လှုပ်ရှားဖွယ်ရာ လုပ်ဆောင်ချက်များကို ခံစားရန် ဤအက်ပလီကေးရှင်းကို ရယူပါ",

    ALREADY_PURCHASED_BUNDLE:
        "မေးခွန်းဝယ်ယူပြီးပြီလား",

    SIGN_IN_TO_PLAY: "ကစားရန် QuizGiri သို့ အကောင့်ဝင်ပါ",

    SIGN_IN_NOW: "ယခုဝင်ရောက်ပါ",

    ENTER_NAME:
        "သင့်အမည်ကို ထည့်သွင်းပါ",

    ENTER_MOBILE:
        "ဂဏန်း 11လုံးပါ မိုဘိုင်းနံပါတ်",

    CREATE_ACCOUNT_WITH_SAME_MOBILE:
        " သင်အနေဖြင့် ယခုပေးထားသောနံပါတ်ဖြင့် QuizGiri အကောင့်ကိုဖန်တီးမည်မှာ သေချာပါသလား",

    PROCEED:
        "ဆက်လက်လုပ်ဆောင်ပါ",

    PURCHASE_PACK:
        "ပက်ကေ့ချ်၀ယ်ပါ",
    PAYMENT_METHOD:
        "ငွေပေးချေရန် နည်းလမ်းများ",

    SELECT_PAYMENT_METHOD: "ငွေပေးချေမှုနည်းလမ်းကို ရွေးပါ။",

    BCS_PACKAGES: "BCS ပက်ကေ့ချ်များ",
    TOURNAMENT_BUNDLES: "ပြိုင်ပွဲ",

    SUBSCRIPTION:
        "ဝန်ဆောင်မှုစာရင်းသွင်းခြင်း",

    SUBSCRIBED: " ဝန်ဆောင်မှုရယူပြီးပါပြီ",
    DUMMY: " နမူနာ",
    DASHBOARD: 'ဒက်ရှ်ဘုတ်',
    MEGA: 'အပတ်စဥ်',
    ERROR: 'အမှား'
}

export default $mm
